import { $api } from "../../../../services/request.config";
import { sendMemoThunkAction } from "../../RequestsFromLeader/RecruitmentToWork/thunk/sendMemo.thunk.action";

export const verifyPasswordThunkAction = (data) => async (dispatch) => {
    const { password, hoc, setPassword, requestCard } = data;
    try {
        const response = await $api.post("v1/auth/verify/password", { password: password.password });
        if (response.status === 204) {
            setPassword((prev) => {
                return {
                    ...prev,
                    sendButtonLoading: false,
                    correctPassword: true,
                };
            });
            hoc.next(hoc.newTuple, hoc.props);
            dispatch(sendMemoThunkAction({ uid: requestCard.uid, employees: hoc.props.pids, hoc }));
        }

    } catch (e) {
        setPassword((prev) => {
            return {
                ...prev,
                sendButtonLoading: false,
                correctPassword: false,
                stateLoader: false,
            };
        });
    }

};
